import axios from 'axios';
import { Profile } from '../types/profile';

// Usar variável de ambiente
const API_BASE_URL = `${import.meta.env.VITE_API_BASE_URL}/api`;
const PROFILES_ENDPOINT = '/profiles';

// Interface para os filtros da API de Perfis
export interface ProfileFilter {
  name?: string;
  ativo?: boolean;
  page?: number;
  pageSize?: number;
  sortField?: string;
  sortOrder?: 'asc' | 'desc';
}

// Interface para a resposta da API getAll
export interface ProfileListResponse {
  data: Profile[];
  totalCount: number;
}

export class ProfileService {
  async getAll(filters?: ProfileFilter): Promise<ProfileListResponse> {
    try {
      // Usar a URL completa
      const response = await axios.get<ProfileListResponse>(`${API_BASE_URL}${PROFILES_ENDPOINT}`, { params: filters });
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar perfis:", error);
      // Re-lançar o erro para ser tratado pelo componente
      throw error; // Ou lançar new Error('Mensagem específica')
    }
  }

  async getById(id: number): Promise<Profile> {
    // Usar a URL completa
    const response = await axios.get<Profile>(`${API_BASE_URL}${PROFILES_ENDPOINT}/${id}`);
    return response.data;
  }

  async create(profile: Partial<Profile>): Promise<Profile> {
    // Usar a URL completa
    const response = await axios.post<Profile>(`${API_BASE_URL}${PROFILES_ENDPOINT}`, profile);
    return response.data;
  }

  async update(id: number, profile: Partial<Profile>): Promise<Profile> {
    // Usar a URL completa
    const response = await axios.put<Profile>(`${API_BASE_URL}${PROFILES_ENDPOINT}/${id}`, profile);
    return response.data;
  }

  async delete(id: number): Promise<void> {
    // Usar a URL completa
    await axios.delete(`${API_BASE_URL}${PROFILES_ENDPOINT}/${id}`);
  }
}